import { type TableColumnWidthInfo } from "@devexpress/dx-react-grid";

export const SELECTION_COLUMN_WIDTH = 49;
export const ROW_HEIGHT = 80;

export const isColumnSortable = (metricName: string) => {
  if (metricName === FIXED_STATUS_COLUMN_ID) {
    return false;
  }
  return true;
};

export const isColumnFilterable = (metricName: string) => {
  if (metricName === FIXED_NAME_COLUMN_ID) {
    return false;
  }

  return true;
};

export const FIXED_NAME_COLUMN_ID = "Name";
export const FIXED_NAME_COLUMN = {
  name: FIXED_NAME_COLUMN_ID,
  id: FIXED_NAME_COLUMN_ID,
  title: FIXED_NAME_COLUMN_ID,
  width: 200,
};

export const FIXED_STATUS_COLUMN_ID = "Status";
export const FIXED_STATUS_COLUMN = {
  name: FIXED_STATUS_COLUMN_ID,
  id: FIXED_STATUS_COLUMN_ID,
  title: "Data status",
  width: 120,
};

export const PACING_STATUS_COLUMN_ID = "pacingStatus";
export const PACING_STATUS_COLUMN = {
  name: PACING_STATUS_COLUMN_ID,
  id: PACING_STATUS_COLUMN_ID,
  title: "Pacing status",
  width: 150,
};

export const SPEND_THERMOMETER_ID = "spendThermometer";
export const SPEND_THERMOMETER_COLUMN = {
  name: SPEND_THERMOMETER_ID,
  id: SPEND_THERMOMETER_ID,
  title: "Pacing to date",
  width: 300,
};

export const TOTAL_BUDGET_COLUMN_ID = "totalBudget";
export const TOTAL_BUDGET_COLUMN = {
  name: TOTAL_BUDGET_COLUMN_ID,
  id: TOTAL_BUDGET_COLUMN_ID,
  title: "Total Budget",
  width: 100,
};

export const BUDGET_FORECAST_PERIOD_ID = "budgetForecastPeriod";
export const BUDGET_FORECAST_PERIOD_COLUMN = {
  name: BUDGET_FORECAST_PERIOD_ID,
  id: BUDGET_FORECAST_PERIOD_ID,
  title: "Budget mix %",
  width: 100,
};

export const ACTUAL_FORECAST_PERIOD_ID = "actualForecastPeriod";
export const ACTUAL_FORECAST_PERIOD_COLUMN = {
  name: ACTUAL_FORECAST_PERIOD_ID,
  id: ACTUAL_FORECAST_PERIOD_ID,
  title: "Actual mix %",
  width: 100,
};

export const BUDGETED_WEEKLY_SPEND_ID = "budgetedWeeklySpend";
export const BUDGETED_WEEKLY_SPEND_COLUMN = {
  name: BUDGETED_WEEKLY_SPEND_ID,
  id: BUDGETED_WEEKLY_SPEND_ID,
  title: "Budgeted (weekly spend)",
  width: 520,
};

export const ACTUAL_WEEKLY_SPEND_ID = "actualWeeklySpend";
export const ACTUAL_WEEKLY_SPEND_COLUMN = {
  name: ACTUAL_WEEKLY_SPEND_ID,
  id: ACTUAL_WEEKLY_SPEND_ID,
  title: "Actual (weekly spend)",
  width: 520,
};

export const AVG_WEEKLY_SPEND_ID = "weeklyAvgSpend";
export const AVG_WEEKLY_SPEND_COLUMN = {
  name: AVG_WEEKLY_SPEND_ID,
  id: AVG_WEEKLY_SPEND_ID,
  title: "AVG weekly spend",
  width: 150,
};

export const MTA_REVENUE_ID = "mtaRevenue" as const;
export const MTA_REVENUE_COLUMN = {
  name: MTA_REVENUE_ID,
  id: MTA_REVENUE_ID,
  title: "MTA: Revenue",
  width: 150,
  format: "dollars",
};

export const MTA_TRANSACTIONS_ID = "mtaTransactions" as const;
export const MTA_TRANSACTIONS_COLUMN = {
  name: MTA_TRANSACTIONS_ID,
  id: MTA_TRANSACTIONS_ID,
  title: "MTA: Transactions",
  width: 150,
  format: "decimal",
};

export const MTA_ROAS_ID = "mtaRoas" as const;
export const MTA_ROAS_COLUMN = {
  name: MTA_ROAS_ID,
  id: MTA_ROAS_ID,
  title: "MTA: ROAS",
  width: 150,
  format: "multiplier",
};

export const MTA_CAC_ID = "mtaCac" as const;
export const MTA_CAC_COLUMN = {
  name: MTA_CAC_ID,
  id: MTA_CAC_ID,
  title: "MTA: CAC",
  width: 150,
  format: "dollars",
};

export const COLUMNS = [
  FIXED_NAME_COLUMN,
  // FIXED_STATUS_COLUMN,
  PACING_STATUS_COLUMN,
  SPEND_THERMOMETER_COLUMN,
  TOTAL_BUDGET_COLUMN,
  BUDGET_FORECAST_PERIOD_COLUMN,
  ACTUAL_FORECAST_PERIOD_COLUMN,
  BUDGETED_WEEKLY_SPEND_COLUMN,
  ACTUAL_WEEKLY_SPEND_COLUMN,
  AVG_WEEKLY_SPEND_COLUMN,
  MTA_REVENUE_COLUMN,
  MTA_TRANSACTIONS_COLUMN,
  MTA_ROAS_COLUMN,
  MTA_CAC_COLUMN,
];

export const DEFAULT_COLUMN_WIDTHS: TableColumnWidthInfo[] = COLUMNS.map(
  ({ name, width }) => ({ columnName: name, width }),
);
